import { Grid, Hidden } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { ButtonWrapper } from '../../../../../global/components/layout/button-wrapper';
import { MainContent } from '../../../../../global/components/layout/main-content-container';
import { PageContainer } from '../../../../../global/components/layout/page-container';
import { PageHeader } from '../../../../../global/components/layout/page-header';
import { SideBarContent } from '../../../../../global/components/layout/sidebar-content';
import { buttonStyles } from '../../../../../global/constants/theme/styles/components/buttonstyles';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { NewHireProps } from '../../../models/arc-epi-props';
import { useGpsType } from '../../../../../global/hooks/useGpsType';
import { GpsType } from '../../../../../global/components/layout/layout-models';
import { GuidedProcessSupportBlock } from '../../../../../global/components/guided-process-support-block';
import { NewHireStipEmploymentCompensationReview } from '../../new-hire/components/stip-employment-comp-fields-review';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { ArcRoutes } from '../../../constants/routes';
import { NewHireEnrollmentRoutes } from '../models/new-hire-routes';




export function EmploymentReview() {

	const buttonClasses = buttonStyles();
	const settings = useSelector<TcsmStates, NewHireProps>(state => state?.epiProps?.newHireSettingsState?.epiContent);
	const gpsItem = useGpsType(GpsType.NEW_HIRE_EMPLOYMENT);
	const whoWillEnrollPath = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.NewHireEnrollment}${NewHireEnrollmentRoutes.WhoWillEnroll}`);
	const history = useHistory();
	const goBack = () => {
		history.goBack();
	};

	const continueAction = () => {
		history.push(whoWillEnrollPath);
	};

	return (
		<PageContainer>
			<MainContent>
				<PageHeader
					headerText={settings?.employmentCompensationReviewPageTitle}
					description={settings?.employmentCompensationReviewPageDescription}
				/>
				<Hidden mdUp>
					<SideBarContent>
						<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem.contents} />
					</SideBarContent>
				</Hidden>
				<NewHireStipEmploymentCompensationReview newHireProps={settings} />
				<ButtonWrapper flexEnd>
					<button className={buttonClasses.tertiaryButton} type='button' onClick={goBack} >{settings.employmentCompensationBackToPersonalInformationButtonText}</button>
					<button className={buttonClasses.primaryButton} type='button' onClick={continueAction} >{settings.continueToWhoWillEnrollButtonText}</button>
				</ButtonWrapper>
				<Grid container direction='row' justifyContent='flex-end'><Grid
					justifyContent='flex-end'
					container
					item md={6}><p>{settings.continueToWhoWillEnrollHelperText}</p>
				</Grid></Grid>
			</MainContent>
			<Hidden smDown>
				<SideBarContent>
					<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem.contents} />
				</SideBarContent>
			</Hidden>
		</PageContainer>
	);
}